
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/widerrufsbelehrung/widerrufsbelehrung-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="widerrufsbelehrung-view">
        <hero-section
            background-image="/images/hero/rechtliches-hero.png"
            headline="Widerrufsbelehrung"
            subheadline="Widerrufsbelehrung von FASE2"
            text="<strong>Hier finden sie unsere rechtlichen Angaben.</strong><br>Informationen zu Ihrem Widerrufsrecht bei Vertragsabschluss mit FASE2."
            button-text2="Jetzt kostenlos beraten lassen!"
            button-link2="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="widerrufsrecht">
                <h2 id="widerrufsrecht">Widerrufsrecht</h2>
                <p>
                    Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
                </p>
                <p>
                    Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses. 
                </p>
                <p>
                    Das Widerrufsrecht erlischt mit der vollständigen Erbringung unserer Dienstleistung, 
                    wenn Sie vor Beginn der Erbringung ausdrücklich zugestimmt haben, dass wir mit der Erbringung der Dienstleistung vor Ablauf der 
                    Widerrufsfrist beginnen. Sie wurden im Rahmen des Vertragsschlusses sowie unserer AGB darauf hingewiesen und haben insoweit 
                    Ihre Kenntnis bestätigt, dass Ihr Widerrufsrecht in diesem Fall mit vollständiger Vertragserfüllung durch uns erlischt 
                    (§ 356 Abs. 4 Nr. 2 Buchstaben a) und c) BGB).
                </p>
            </article>

            <article aria-labelledby="ausuebung-widerrufsrecht">
                <h2 id="ausuebung-widerrufsrecht">Ausübung des Widerrufsrechts</h2>
                <p>
                    Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (FASE2, Inhaber: Salvatore Laudani und Hüseyin Sidar, Reinoldstr. 6b, 50676 Köln, 
                    Tel.: 0221 94085999, <a href="mailto:hallo@fase2.de">hallo@fase2.de</a>) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief, 
                    Telefon oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
                </p>
                <p>
                    Sie können dafür das Muster-Widerrufsformular oder eine andere eindeutige Erklärung auch auf unserer Website 
                    <a href="/widerrufsbelehrung" target="_blank">https://fase2.de/widerrufsbelehrung</a> elektronisch ausfüllen und übermitteln. 
                    Machen Sie von dieser Möglichkeit Gebrauch, so werden wir Ihnen unverzüglich (z. B. per E-Mail) eine Bestätigung über den Eingang eines solchen Widerrufs übermitteln.
                </p>
                <p>
                    Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
                </p>
            </article>

            <article aria-labelledby="folgen-widerruf">
                <h2 id="folgen-widerruf">Folgen des Widerrufs</h2>
                <p>
                    Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen 
                    vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
                </p>
                <p>
                    Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, 
                    mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
                </p>
                <p>
                    Haben Sie verlangt, dass die Dienstleistungen während der Widerrufsfrist beginnen sollen, so haben Sie uns einen angemessenen Betrag zu zahlen, 
                    der dem Anteil der bis zu dem Zeitpunkt, zu dem Sie uns von der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, 
                    bereits erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag vorgesehenen Dienstleistungen entspricht 
                    (§ 357a Abs. 2 S. 1 Nr. 1 und 3, S. 2 BGB).
                </p>
            </article>
        </div>
    </section>`,
      style: `widerrufsbelehrung-view .widerrufsbelehrung-view {
  margin: 0;
  padding: 0;
}
widerrufsbelehrung-view .widerrufsbelehrung-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
widerrufsbelehrung-view .widerrufsbelehrung-view .wrapper article {
  margin: 0 0 32px 0;
  padding: 0;
}
widerrufsbelehrung-view .widerrufsbelehrung-view .wrapper aside {
  margin: 0 0 32px 0;
  padding: 0;
}
@media (max-width: 992px) {
  widerrufsbelehrung-view .widerrufsbelehrung-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    events: [
        ['click', '.widerrufsbelehrung-view a[href^="/"]:not([target])', function (event) {
                event.preventDefault();
                if (this.buttonLink2)
                    router.navigate(this.buttonLink2);
            }],
    ]
};
 })()`
    };
  